<div class="bulb-classic-editor-container">
  <div *ngIf="showCharacterCounter"
       class="bulb-character-counter"
       [ngClass]="{ 'bulb-character-counter-error': isMaxlengthReached }">{{characterCount}}/{{maxLength}}</div>
  <ckeditor [ngClass]="{ 'bulb-error': showCharacterCounter && isMaxlengthReached }"
            [editor]="classicEditorBuild"
            [config]="defaultConfig"
            (ready)="onReady($event)"
            [data]= "data">
  </ckeditor>
  <p *ngIf="showCharacterCounter && isMaxlengthReached"
     class="bulb-char-limit-message" transloco="contentEditor.characterLimitErrorMessage">Character limit exceeded.</p>
</div>

